export default __webpack_public_path__ + "static/media/Juli.ce5cbb3f.jpeg";